import React from "react";
import { Link } from "react-router-dom";
import PermissionsGate from "../../../utils/permissionGate";
import Hover from "../../common/Hover";
import { InitialRender } from "../../common/Helper";
import { ColorRender } from "../../systemadministration/usermanagement/CheckRole";
import { IMAGE_URL } from "../../../utils/Constants";

/**
 * A user the way AMI's User Management list shows one - profile picture (or initials), online
 * status dot, hover card, and the name linking to their profile for anyone who can edit users.
 * @param {Object} props
 * @param {Object} props.user Row with UserID/user_id, Firstname, Lastname, Email, Mobile, picture_me, role_name, user_status, user_activity_status.
 */
function OhsUserCell({ user }) {
    const userId = user.user_id || user.value;
    const activityStatus = (user.user_activity_status || "").toLowerCase();
    // cms_users.Status holds the live activity - anything other than online/away shows as offline.
    const activityClass = { online: "Online", away: "Away" }[activityStatus] || "Offline";

    return (
        <div className="assigned-title-block-new">
            <div className="assigned-title-itm">
                <span className={`assigned-title-blk name-icon cat-dark-red ${ColorRender(user.role_name)}`}>
                    {user.picture_me
                        ? <img src={`${IMAGE_URL}/${user.picture_me.replace("/home/myaie/public_html/", "")}`} alt="AIE" />
                        : InitialRender([user.Firstname, user.Lastname])}
                    <span className={`profile-box-2-status ${activityClass}`}>
                        <i className="fas fa-circle"></i>
                    </span>
                    <Hover
                        firstName={user.Firstname}
                        lastName={user.Lastname}
                        photo={user.picture_me}
                        email={user.Email}
                        mobile={user.Mobile}
                        status={user.user_status}
                        activity_status={user.user_activity_status}
                        right={true}
                        role={user.role_name}
                    />
                </span>
                <PermissionsGate scopes={["umedit"]} RenderError={() => <p>{user.Firstname} {user.Lastname}</p>}>
                    <Link className="as-text-blue curser feature-name" to={`/systemAdministration/userManagement/open/${userId}/aboutYou`}>
                        <span className="textLimit100">{user.Firstname} {user.Lastname}</span>
                    </Link>
                </PermissionsGate>
            </div>
        </div>
    );
}

export default OhsUserCell;
